import { useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import useApprovalFieldNavigateTab from "../../../../pages/NewAdsCampaign/hooks/useApprovalFieldNavigateTab";
import {
  ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META,
  ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH,
  ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH,
  ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ALERT_ICON_TYPE_SUCCESS,
  IMAGE_FORMATS,
  META,
  MIN_DIMENSIONS_CONTENT,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  VIDEO_FORMATS,
} from "../../../../utils/constants";
import { useCreditActionCosts } from "../../../../hooks/useCreditActionCosts";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import { getIsBlockedActions } from "../../../../actions/getters";
import { useDispatchApp } from "../../../../lib/redux";
import { generalFormatMediaUrl } from "../../../../services/adsCampaigns";
import {
  generateAdsCampaignDescription,
  startDeleteAdMediaID,
} from "../../../../actions/adsCampaigns";
import { getUniqueID } from "../../../../utils/numbers";
import { useMediaQuery } from "@mui/material";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  APP_PLACEHOLDER,
  CALL_TO_ACTION_PLACEHOLDER,
  CAROUSEL,
  CATALOG_CARD,
  CONTENT,
  COPY_VALUES_IN_OTHER_ADS,
  CREATIVE_TYPE_PLACEHOLDER,
  DESCRIPTION_PLACEHOLDER,
  DESCRIPTIONS,
  DESTINATION_URL_PLACEHOLDER,
  EDIT_CREATIVE_TOOLS_PLACEHOLDER,
  FIELD_MAX_LENGTH,
  FIELD_REQUIRED,
  FIELD_TEXT_REPEATED,
  HEADLINE_PLACEHOLDER,
  HEADLINES,
  INDIVIDUAL,
  INTRO_CARD,
  IOS_DEEP_LINK_PLACEHOLDER,
  PROFILE_CARD,
  READY,
  SINGLE_IMAGE,
  SLIDES_SHOW,
  TITLE_PLACEHOLDER,
  INSTANT_EXPERIENCE,
  INSTANT_EXPERIENCE_PLACEHOLDER,
  ANDROID_DEEP_LINK_PLACEHOLDER,
  DEEP_DESTINATION_APP_URL_PLACEHOLDER,
  UTM_PARAMETERS_PLACEHOLDER,
  ADS_CAMPAIGN_PREVIEW,
  ADS_CONFIGURATION_DESTINATION_TITLE,
  ADS_CONFIGURATION_APPS_TITLE,
  CREATIVE_SOURCE_PLACEHOLDER,
  MANUAL_UPLOAD_PLACEHOLDER,
  ADVANTAGE_CATALOG_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE,
  PROMOTED_PRODUCTS_PLACEHOLDER,
  CATALOG_PLACEHOLDER,
  TRACKING_WEBSITE_EVENTS,
  AD_SCHEDULE_PLACEHOLDER,
  TITLES_META,
  TRACKING_EVENTS,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
} from "../../../../i18n/keysTranslations";
import IconButton from "@mui/material/IconButton";
import Widgets from "@mui/icons-material/Widgets";
import TextField from "../../../Form/TextField";
import { waitDelay } from "../../../../utils/date";
import Select from "../../../Form/Select";
import EditAdvantageEnhances from "./EditAdvantageEnhances";
import ClickableText from "../../../Texts/ClickableText";
import { SimpleAlert } from "../../../Alerts/Alerts";
import SelectCallToActionMeta from "./SelectCallToActionMeta";
import ButtonMenu from "../../../Buttons/ButtonMenu";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import ContentField from "../../../Form/ContentField";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditCreativeTools from "./EditCreativeTools";
import SelectAdvertisableAppsMeta from "./SelectAdvertisableAppsMeta";
import InstantExperienceContainer from "./InstantExperienceContainer/InstantExperienceContainer";
import {
  CARD_TYPES,
  getShowAdScheduleMeta,
  MAP_CUSTOM_PAGE_ID_PLACEHOLDER,
} from "../../../../services/meta";
import ChipOptional from "../../../Chip/ChipOptional";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SelectProductsSetMeta from "../Campaign/SelectProductsSetMeta";
import SelectCatalogMeta from "../Campaign/SelectCatalogMeta";
import SelectTrackingIDField from "../../../Form/SelectTrackingIDField";
import AdScheduleContainerMeta from "./AdScheduleContainerMeta";
import AdPreviewMeta from "./AdPreviewMeta";
import CardContainer from "../../../Card/CardContainer";
import CardContainerWithCopy from "../../../Card/CardContainerWithCopy";
import { INPUT_COLOR_BORDER, BOX_SHADOW_THEME } from "../../../../utils/colors";
import TextFieldWithActions from "../../../Form/TextFieldWithActions";
import UtmParametersContainer from "../../../Common/Utms/UtmParametersContainer";
import DestinationFallbackConfiguration from "../../../Common/DestinationFallbackConfiguration";

const CREATIVE_TYPES = {
  CAROUSEL: "carousel",
  INSTANT_EXPERIENCE: "instantExperience",
  INDIVIDUAL: "individual",
};

const CARD_TYPES_LABELS = {
  [CARD_TYPES.INTRO]: INTRO_CARD,
  [CARD_TYPES.CATALOG]: CATALOG_CARD,
  [CARD_TYPES.PROFILE]: PROFILE_CARD,
};

const CARD_CREATIVE_TYPES = {
  SINGLE_IMAGE: "singleImage",
  SLIDES_SHOW: "slidesShow",
};

const platform = META;
const grid = {
  xs: 12,
  lg: 6,
};

const getCreativeTypes = ({ isSalesCampaign }) => {
  const creativeTypes = [
    {
      value: CREATIVE_TYPES.INDIVIDUAL,
      label: INDIVIDUAL,
    },
    {
      value: CREATIVE_TYPES.CAROUSEL,
      label: CAROUSEL,
    },
  ];
  if (isSalesCampaign) {
    creativeTypes.push({
      value: CREATIVE_TYPES.INSTANT_EXPERIENCE,
      label: INSTANT_EXPERIENCE,
    });
  }

  return creativeTypes;
};

const AdCatalogMetaForm = () => {
  const refPreview = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const {
    watch,
    getValues,
    control,
    formState,
    sectionSelected,
    isGeneralDisabledFields,
    setValue,
    trigger,
    isChatVisible,
  } = useFormContext();
  useFocusErrorForm(formState);

  const breakColumnFormAndPreview = useMediaQuery(() => "(max-width: 1080px)");
  const isLargeScreen = useMediaQuery(
    () => `(min-width: ${MIN_WIDTH_SCREEN_TO_SHOW_CHAT}px)`
  );
  const showSlideChat = isChatVisible && isLargeScreen;

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { ADS_CAMPAIGN_GENERATE_TEXT_ACTION } = useCreditActionCosts();
  const errors = formState.errors;
  const adsGroups = watch("adsGroups");

  const adGroupID = sectionSelected.adGroupID;
  const indexAdGroup = adsGroups.findIndex((item) => item.id === adGroupID);
  const adGroup = adsGroups[indexAdGroup];
  const BASIC_PATH_AD_GROUP = `adsGroups.[${indexAdGroup}]`;

  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );

  const adID = sectionSelected.adID;
  const indexAd = adGroup?.ads?.findIndex((item) => item.id === adID);
  const BASIC_PATH = `adsGroups.[${indexAdGroup}].ads.[${indexAd}]`;
  const creativeType = watch(`${BASIC_PATH}.creativeType`);
  const isIncompatibleAd = getValues(`${BASIC_PATH}.isIncompatible`) || false;
  const isCarousel = watch(`${BASIC_PATH}.isCarousel`);
  const isInstantExperience = watch(`${BASIC_PATH}.isInstantExperience`);
  const platformData = watch(`platformsData.${platform}`);
  const objective = platformData?.objective;

  const showCreativeSource =
    !platformData?.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const showDestinationFallbackConfiguration =
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION ||
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION;

  const isDisabledFields =
    isGeneralDisabledFields ||
    platformData?.isIncompatible ||
    adGroup?.isIncompatible ||
    isIncompatibleAd;

  const getCatalogID = () => {
    if (platformData?.isCatalogCampaign) {
      return platformData?.catalogID;
    }
    if (
      ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
        destinationTypeAdGroup
      )
    ) {
      const catalogID = getValues(`${BASIC_PATH_AD_GROUP}.catalogID`);
      if (catalogID) {
        return catalogID;
      }
    }

    return getValues(`${BASIC_PATH}.catalogID`);
  };
  const getProductSetID = () => {
    if (
      platformData?.isCatalogCampaign ||
      ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
        destinationTypeAdGroup
      )
    ) {
      const productSetID = getValues(`${BASIC_PATH_AD_GROUP}.productSetID`);

      return productSetID;
    }

    return getValues(`${BASIC_PATH}.productSetID`);
  };

  const catalogID = getCatalogID();

  const onGenerateText = async ({ type, index }) => {
    const isBlocked = await dispatch(
      getIsBlockedActions({
        action: ADS_CAMPAIGN_GENERATE_TEXT_ACTION,
        showUsageConfirmationAlert: true,
      })
    );
    if (isBlocked) {
      return;
    }

    const currentTexts = getValues(`${BASIC_PATH}.${type}`) || [];
    const currentText = currentTexts[index]?.value || "";
    const allTexts = currentTexts.map((item) => item.value || "");
    const textsWithCurrentFirst = [
      currentText,
      ...allTexts.filter((_, i) => i !== index),
    ];

    const response = await dispatch(
      generateAdsCampaignDescription({
        objective,
        platform,
        campaignContext: getValues("context") || "",
        destinationUrl:
          getValues(`${BASIC_PATH}.destinationUrls`)?.[0]?.value || "",
        language: getValues(`language`),
        type,
        currentTexts: textsWithCurrentFirst,
      })
    );

    if (response) {
      setValue(`${BASIC_PATH}.${type}.[${index}].value`, response);
      trigger(`${BASIC_PATH}.${type}.[${index}].value`);
      onGeneratePreview();
    }
  };

  const onChangeCreativeType = async (value) => {
    const currentMediaUrls = watch(`${BASIC_PATH}.mediaUrls`) || [""];
    const currentMediaData = watch(`${BASIC_PATH}.mediaData`) || [
      { from: "upload" },
    ];
    const currentHeadlines = watch(`${BASIC_PATH}.headlines`) || [
      { value: "" },
    ];
    const currentDescriptions = watch(`${BASIC_PATH}.descriptions`) || [
      { value: "" },
    ];

    if (value === CREATIVE_TYPES.CAROUSEL) {
      const newMediaData = [...currentMediaData];
      newMediaData[0] = {
        ...newMediaData[0],
        type: CARD_TYPES.CATALOG,
        creativeType: CARD_CREATIVE_TYPES.SINGLE_IMAGE,
      };

      setValue(`${BASIC_PATH}.mediaData`, newMediaData);
      setValue(`${BASIC_PATH}.mediaUrls`, [""]);
    } else {
      let catalogIndex = currentMediaData.findIndex(
        (data) => data.type === CARD_TYPES.CATALOG
      );

      if (catalogIndex === -1) {
        catalogIndex = 0;
      }

      delete currentMediaData[catalogIndex].type;
      delete currentMediaData[catalogIndex].creativeType;
      setValue(`${BASIC_PATH}.mediaUrls`, [
        currentMediaUrls[catalogIndex] || "",
      ]);
      setValue(`${BASIC_PATH}.mediaData`, [
        currentMediaData[catalogIndex] || { from: "upload" },
      ]);
      setValue(`${BASIC_PATH}.headlines`, [
        currentHeadlines[catalogIndex] || { value: "", id: getUniqueID() },
      ]);
      setValue(`${BASIC_PATH}.descriptions`, [
        currentDescriptions[catalogIndex] || { value: "", id: getUniqueID() },
      ]);
    }

    onGeneratePreview();
  };

  const onCopyValuesInOtherAds = ({ type }) => {
    const value = getValues(`${BASIC_PATH}.${type}`);
    const adsOnAdgroup = getValues(`${BASIC_PATH_AD_GROUP}.ads`) || [];

    adsOnAdgroup.forEach((ad, currentIndexAd) => {
      if (ad.id === adID) return;

      setValue(`${BASIC_PATH_AD_GROUP}.ads.[${currentIndexAd}].${type}`, value);
    });

    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const onGeneratePreview = () => {
    if (refPreview?.current) {
      refPreview?.current?.generatePreview();
    }
  };

  const onChangeCreativeSource = (value) => {
    setValue(`${BASIC_PATH}.isCarousel`, false);
    setValue(`${BASIC_PATH}.isInstantExperience`, false);

    setValue(`${BASIC_PATH}.mediaUrls`, [""]);
    setValue(`${BASIC_PATH}.mediaData`, [{ from: "upload" }]);
    setValue(`${BASIC_PATH}.productSetID`, "");

    if (ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG === value) {
      setValue(
        `${BASIC_PATH}.titles`,
        getValues(`${BASIC_PATH}.titles`).slice(0, 1)
      );
      setValue(
        `${BASIC_PATH}.descriptions`,
        getValues(`${BASIC_PATH}.descriptions`).slice(0, 1)
      );
      setValue(
        `${BASIC_PATH}.headlines`,
        getValues(`${BASIC_PATH}.headlines`).slice(0, 1)
      );
    }

    if (ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL === value) {
      setValue(
        `${BASIC_PATH}.titles`,
        getValues(`${BASIC_PATH}.titles`).slice(0, 3)
      );
      setValue(
        `${BASIC_PATH}.descriptions`,
        getValues(`${BASIC_PATH}.descriptions`).slice(0, 3)
      );
      setValue(
        `${BASIC_PATH}.headlines`,
        getValues(`${BASIC_PATH}.headlines`).slice(0, 3)
      );
    }

    onGeneratePreview();
    setValue(`${BASIC_PATH}.creativeSource`, value);
  };

  //To reset values component when change selectedLevel
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  useEffect(() => {
    if (isCarousel) {
      setValue(`${BASIC_PATH}.creativeType`, CREATIVE_TYPES.CAROUSEL);
    } else if (isInstantExperience) {
      setValue(`${BASIC_PATH}.creativeType`, CREATIVE_TYPES.INSTANT_EXPERIENCE);
    } else {
      setValue(`${BASIC_PATH}.creativeType`, CREATIVE_TYPES.INDIVIDUAL);
    }

    const productSetID = getValues(`${BASIC_PATH}.productSetID`);
    if (!productSetID) {
      setValue(`${BASIC_PATH}.productSetID`, getProductSetID());
    }

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (creativeType === CREATIVE_TYPES.CAROUSEL) {
      setValue(`${BASIC_PATH}.isCarousel`, true);
      setValue(`${BASIC_PATH}.isInstantExperience`, false);
    } else if (creativeType === CREATIVE_TYPES.INSTANT_EXPERIENCE) {
      setValue(`${BASIC_PATH}.isCarousel`, false);
      setValue(`${BASIC_PATH}.isInstantExperience`, true);
    } else {
      setValue(`${BASIC_PATH}.isCarousel`, false);
      setValue(`${BASIC_PATH}.isInstantExperience`, false);
    }

    //eslint-disable-next-line
  }, [creativeType]);

  useEffect(() => {
    if (!showCreativeSource) return;

    const creativeSource = getValues(`${BASIC_PATH}.creativeSource`);
    if (!creativeSource)
      setValue(
        `${BASIC_PATH}.creativeSource`,
        ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL
      );
    // eslint-disable-next-line
  }, []);

  if (isLoading || !creativeType) return null;

  return (
    <>
      {creativeType === CREATIVE_TYPES.CAROUSEL && (
        <AdCarouselCatalogForm
          objective={objective}
          platform={platform}
          platformData={platformData}
          breakColumnFormAndPreview={breakColumnFormAndPreview}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          BASIC_PATH={BASIC_PATH}
          gridItems={grid}
          onGenerateText={onGenerateText}
          isGeneralDisabledFields={isDisabledFields}
          errors={errors}
          control={control}
          refPreview={refPreview}
          onGeneratePreview={onGeneratePreview}
          onChangeCreativeType={onChangeCreativeType}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
          onChangeCreativeSource={onChangeCreativeSource}
          catalogID={catalogID}
          showCreativeSource={showCreativeSource}
          showDestinationFallbackConfiguration={
            showDestinationFallbackConfiguration
          }
          indexAdGroup={indexAdGroup}
          indexAd={indexAd}
          showSlideChat={showSlideChat}
        />
      )}

      {creativeType === CREATIVE_TYPES.INDIVIDUAL && (
        <AdSingleMediaCatalogForm
          objective={objective}
          platform={platform}
          breakColumnFormAndPreview={breakColumnFormAndPreview}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          BASIC_PATH={BASIC_PATH}
          gridItems={grid}
          onGenerateText={onGenerateText}
          isGeneralDisabledFields={isDisabledFields}
          errors={errors}
          control={control}
          refPreview={refPreview}
          onChangeCreativeType={onChangeCreativeType}
          onGeneratePreview={onGeneratePreview}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
          platformData={platformData}
          onChangeCreativeSource={onChangeCreativeSource}
          catalogID={catalogID}
          showCreativeSource={showCreativeSource}
          showDestinationFallbackConfiguration={
            showDestinationFallbackConfiguration
          }
          showSlideChat={showSlideChat}
        />
      )}

      {creativeType === CREATIVE_TYPES.INSTANT_EXPERIENCE && (
        <AdInstantExperienceCatalogForm
          objective={objective}
          platform={platform}
          breakColumnFormAndPreview={breakColumnFormAndPreview}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          BASIC_PATH={BASIC_PATH}
          gridItems={grid}
          onGenerateText={onGenerateText}
          isGeneralDisabledFields={isDisabledFields}
          errors={errors}
          control={control}
          refPreview={refPreview}
          onChangeCreativeType={onChangeCreativeType}
          onGeneratePreview={onGeneratePreview}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
          platformData={platformData}
          onChangeCreativeSource={onChangeCreativeSource}
          catalogID={catalogID}
          showCreativeSource={showCreativeSource}
          showDestinationFallbackConfiguration={
            showDestinationFallbackConfiguration
          }
          showSlideChat={showSlideChat}
        />
      )}
    </>
  );
};

const AdInstantExperienceCatalogForm = ({
  objective,
  platform,
  breakColumnFormAndPreview,
  BASIC_PATH_AD_GROUP,
  BASIC_PATH,
  onGenerateText,
  isSpecialAdWithOnlyTitles,
  isGeneralDisabledFields,
  errors,
  control,
  refPreview,
  onChangeCreativeType,
  onGeneratePreview,
  onCopyValuesInOtherAds,
  platformData,
  onChangeCreativeSource,
  catalogID,
  showCreativeSource,
  showSlideChat,
  showDestinationFallbackConfiguration,
}) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();

  const isSalesCampaign = objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;
  const isAppPromotionCampaign =
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION;

  const maxLengthTitle = ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH[platform];
  const maxLengthHeadline = ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH[platform];

  const adID = watch(`${BASIC_PATH}.id`);

  const language = watch("language");

  const mediaUrls = watch(`${BASIC_PATH}.mediaUrls`);
  const mediaData = watch(`${BASIC_PATH}.mediaData`);
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const titles = watch(`${BASIC_PATH}.titles`) || [{ value: "" }];
  const headlines = watch(`${BASIC_PATH}.headlines`) || [{ value: "" }];
  const descriptions = watch(`${BASIC_PATH}.descriptions`) || [{ value: "" }];
  const productSetID = watch(`${BASIC_PATH}.productSetID`);
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );
  const appID = watch(`${BASIC_PATH_AD_GROUP}.appID`);

  const status = watch(`${BASIC_PATH}.status`);
  const isAdCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;

  const showTrackingID =
    !(
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationTypeAdGroup ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      !platformData.isCatalogCampaign
    ) &&
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.filter(
      (i) => i !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    ).includes(destinationTypeAdGroup);

  const showTrackingOfflineID =
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationTypeAdGroup
    );
  const isSalesWithAppCatalog =
    !platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    (ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    ) ||
      ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID.includes(
        destinationTypeAdGroup
      ));

  const isApp =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    );

  const showAdSchedule = getShowAdScheduleMeta({ objective });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: breakColumnFormAndPreview ? "column" : "row",
        gap: 3,
        width: "100%",
        flexWrap: showSlideChat ? "wrap" : "nowrap",
      }}
    >
      {/* Form */}
      <Grid
        container
        spacing={3}
        sx={{
          height: "min-content",
        }}
      >
        {/* Card Creative Source */}
        {showCreativeSource && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(CREATIVE_SOURCE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name={`${BASIC_PATH}.creativeSource`}
                  render={({ field }) => (
                    <FormControl component="fieldset">
                      <RadioGroup
                        value={field.value}
                        onChange={(e) => {
                          onChangeCreativeSource(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value={ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL}
                          control={<Radio />}
                          label={<Box>{t(MANUAL_UPLOAD_PLACEHOLDER)}</Box>}
                        />
                        <FormControlLabel
                          value={
                            ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
                          }
                          control={<Radio />}
                          label={<Box>{t(ADVANTAGE_CATALOG_PLACEHOLDER)}</Box>}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 1: Creative Type */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(CREATIVE_TYPE_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Select
                    disabled={isGeneralDisabledFields || isAdCreated}
                    variant="filled"
                    name={`${BASIC_PATH}.creativeType`}
                    doTranslate={true}
                    actionsChange={(value) => {
                      onChangeCreativeType(value);
                    }}
                    control={control}
                    options={getCreativeTypes({
                      isSalesCampaign,
                      isAppPromotionCampaign,
                    })}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <InstantExperienceContainer
                  label={t(INSTANT_EXPERIENCE_PLACEHOLDER)}
                  name={`${BASIC_PATH}.instantExperience`}
                  onCallbackProductInformation={({
                    productSetID,
                    catalogID,
                  }) => {
                    setValue(`${BASIC_PATH}.productSetID`, productSetID);
                    setValue(`${BASIC_PATH}.catalogID`, catalogID);
                  }}
                  integrationID={platformData?.integrationID}
                  adAccountID={platformData?.adAccountID}
                  catalogID={catalogID}
                  productSetID={productSetID}
                  pageID={platformData?.pageID}
                  destinationType={destinationTypeAdGroup}
                  disabledProductConfiguration={!isSalesWithAppCatalog}
                  appID={appID}
                  disabled={
                    !platformData?.pageID ||
                    !platformData?.integrationID ||
                    isGeneralDisabledFields
                  }
                  fullWidth
                  language={language}
                  control={control}
                  errors={errors}
                />
              </Grid>
            </Grid>
          </CardContainer>
        </Grid>

        {showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <DestinationFallbackConfiguration
                basicPath={BASIC_PATH}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                hideTitle={true}
                onCopyValuesInOtherAds={onCopyValuesInOtherAds}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: Destination */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(ADS_CONFIGURATION_DESTINATION_TITLE)}
                </Typography>
              </Box>
            }
          >
            <Grid container spacing={2}>
              {isSalesWithAppCatalog && (
                <>
                  <Grid item xs={isSalesWithAppCatalog ? 6 : 12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body1">
                          {t(
                            isApp
                              ? DEEP_DESTINATION_APP_URL_PLACEHOLDER
                              : DESTINATION_URL_PLACEHOLDER
                          )}
                        </Typography>
                      </Box>
                      <TextField
                        name={`${BASIC_PATH}.destinationUrls.[0].value`}
                        variant="filled"
                        fullWidth
                        disabled={isGeneralDisabledFields}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "destinationUrls" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                </>
              )}
              {!isSalesWithAppCatalog && (
                <Grid item xs={isSalesWithAppCatalog ? 6 : 12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {t(UTM_PARAMETERS_PLACEHOLDER)}
                      </Typography>
                      <ChipOptional size="small" />
                    </Box>
                    <UtmParametersContainer
                      name={`${BASIC_PATH}.utmParameters`}
                      control={control}
                      errors={errors}
                      disabled={isGeneralDisabledFields}
                      platform={platform}
                      onCopyValuesInOtherAds={() =>
                        onCopyValuesInOtherAds({ type: "utmParameters" })
                      }
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </CardContainer>
        </Grid>

        {(showTrackingID || showTrackingOfflineID) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(TRACKING_EVENTS)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showTrackingID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_WEBSITE_EVENTS)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
                {showTrackingOfflineID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingOfflineID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showAdSchedule && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <AdScheduleContainerMeta
                BASIC_PATH={`${BASIC_PATH}`}
                control={control}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 7: Titles */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.titles`}
        >
          <CardContainerWithCopy
            title={t(TITLES_META)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "titles" })}
            id={`${BASIC_PATH}.titles`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box
              lg={isSpecialAdWithOnlyTitles ? 12 : 6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {titles?.map((title, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  labelTitle={t(TITLE_PLACEHOLDER) + " " + (index + 1)}
                  key={title.id}
                  type="titles"
                  name={`${BASIC_PATH}.titles.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  platform={platform}
                  onChange={onGeneratePreview}
                  maxLength={maxLengthTitle}
                  showDeleteIcon={false}
                  onGenerate={async () => {
                    await onGenerateText({ type: "titles", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                    validate: (value) => {
                      if (value.length > maxLengthTitle) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthTitle,
                        });
                      }

                      const allTitles = titles.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allTitles.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) {
                        return t(FIELD_TEXT_REPEATED);
                      }
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>

        {/* Card 8: Headlines */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.headlines`}
        >
          <CardContainer
            title={
              <>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(HEADLINES)}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "flex-end",
                  }}
                >
                  <ClickableText
                    disabled={isGeneralDisabledFields}
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "headlines" })
                    }
                  >
                    {t(COPY_VALUES_IN_OTHER_ADS)}
                  </ClickableText>
                </Box>
              </>
            }
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {headlines?.map((headline, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  labelTitle={t(HEADLINE_PLACEHOLDER) + " " + (index + 1)}
                  key={headline.id}
                  type="headlines"
                  name={`${BASIC_PATH}.headlines.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  platform={platform}
                  onChange={onGeneratePreview}
                  maxLength={maxLengthHeadline}
                  showAddIcon={false}
                  showDeleteIcon={false}
                  onGenerate={async () => {
                    await onGenerateText({ type: "headlines", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                    validate: (value) => {
                      if (value.length > maxLengthHeadline) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthHeadline,
                        });
                      }
                      const allHeadlines = headlines.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allHeadlines.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) {
                        return t(FIELD_TEXT_REPEATED);
                      }
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainer>
        </Grid>
      </Grid>

      {/* Preview */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
        }}
      >
        <CardContainer
          dynamicHeight={true}
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ fontWeight: 600 }} variant="h6">
                {t(ADS_CAMPAIGN_PREVIEW)}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {!isGeneralDisabledFields && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <EditAdvantageEnhances
                      disabled={isGeneralDisabledFields}
                      adID={adID}
                      adPathForm={BASIC_PATH}
                      onCallbackSelect={(newAdvantageEnhances) => {
                        setValue(
                          `${BASIC_PATH}.advantageEnhances`,
                          newAdvantageEnhances
                        );
                        onGeneratePreview();
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AdPreviewMeta
              ref={refPreview}
              adID={adID}
              mediaUrls={mediaUrls}
              mediaData={mediaData}
              callToAction={callToAction}
              titles={titles}
              headlines={headlines}
              descriptions={descriptions}
              platform={platform}
              basicPath={BASIC_PATH}
              basicPathAdGroup={BASIC_PATH_AD_GROUP}
            />
          </Box>
        </CardContainer>
      </Box>
    </Box>
  );
};

const AdCarouselCatalogForm = ({
  objective,
  platform,
  platformData,
  breakColumnFormAndPreview,
  BASIC_PATH_AD_GROUP,
  BASIC_PATH,
  gridItems,
  onGenerateText,
  isGeneralDisabledFields,
  errors,
  control,
  refPreview,
  onGeneratePreview,
  onChangeCreativeType,
  onCopyValuesInOtherAds,
  onChangeCreativeSource,
  catalogID,
  showCreativeSource,
  indexAdGroup,
  indexAd,
  showSlideChat,
  showDestinationFallbackConfiguration,
}) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [tabIndex, setTabIndex] = useState(0);

  useApprovalFieldNavigateTab({
    formPath: BASIC_PATH,
    onSelectIndex: setTabIndex,
  });

  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  const errorMediaUrl = getReactHookFormNestedError(
    errors,
    `${BASIC_PATH}.mediaUrls`
  );

  const isIOS14Campaign = platformData?.isIOS14Campaign;
  const isSalesCampaign = objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;
  const isAppPromotionCampaign =
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION;

  const maxLengthTitle = ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH[platform];
  const maxLengthDescription =
    ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH[platform];
  const maxLengthHeadline = ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH[platform];

  const adID = watch(`${BASIC_PATH}.id`);
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );
  const language = watch("language");
  const ageRange = watch(`${BASIC_PATH_AD_GROUP}.ageRange`);
  const genders = watch(`${BASIC_PATH_AD_GROUP}.genders`);
  const mediaUrls = watch(`${BASIC_PATH}.mediaUrls`) || [""];
  const mediaData = watch(`${BASIC_PATH}.mediaData`) || [{}];
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const titles = watch(`${BASIC_PATH}.titles`) || [{ value: "" }];
  const headlines = watch(`${BASIC_PATH}.headlines`) || [{ value: "" }];
  const descriptions = watch(`${BASIC_PATH}.descriptions`) || [{ value: "" }];
  const destinationUrls = watch(`${BASIC_PATH}.destinationUrls`) || [
    { value: "" },
  ];

  const status = watch(`${BASIC_PATH}.status`);
  const isAdCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;
  const platformsData = watch("platformsData") || {};

  const showTrackingID =
    !(
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationTypeAdGroup ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      !platformData.isCatalogCampaign
    ) &&
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.filter(
      (i) => i !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    ).includes(destinationTypeAdGroup);

  const showTrackingOfflineID =
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationTypeAdGroup
    );

  const isSalesCatalogCampaign =
    platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const catalogCardIndex = mediaData.findIndex(
    (item) => item.type === CARD_TYPES.CATALOG
  );

  useEffect(() => {
    const fields = ["destinationUrls", "headlines", "descriptions"];
    let firstErrorIndex = null;
    for (const field of fields) {
      const fieldErrors =
        errors?.adsGroups?.[indexAdGroup]?.ads?.[indexAd]?.[field];
      if (Array.isArray(fieldErrors)) {
        const idx = fieldErrors.findIndex((item) => item && item.value);
        if (idx !== -1 && (firstErrorIndex === null || idx < firstErrorIndex)) {
          firstErrorIndex = idx;
        }
      }
    }
    if (firstErrorIndex !== null && tabIndex !== firstErrorIndex) {
      setTabIndex(firstErrorIndex);
    }
    //eslint-disable-next-line
  }, [errors, indexAdGroup, indexAd]);

  const onAddCard = (type) => {
    const currentMediaUrls = watch(`${BASIC_PATH}.mediaUrls`) || [""];
    const currentMediaData = watch(`${BASIC_PATH}.mediaData`) || [{}];
    const currentHeadlines = watch(`${BASIC_PATH}.headlines`) || [
      { value: "" },
    ];
    const currentDescriptions = watch(`${BASIC_PATH}.descriptions`) || [
      { value: "" },
    ];
    // Validate if we can add more cards
    if (currentMediaUrls.length >= 3) return;

    // Add new card based on type
    const newMediaUrls = [...currentMediaUrls];
    const newMediaData = [...currentMediaData];
    const newHeadlines = [...currentHeadlines];
    const newDescriptions = [...currentDescriptions];

    if (type === CARD_TYPES.INTRO) {
      // Add intro at the beginning
      newMediaUrls.unshift("");
      newMediaData.unshift({
        type: CARD_TYPES.INTRO,
      });
      newHeadlines.unshift({ value: "", id: getUniqueID() });
      newDescriptions.unshift({ value: "", id: getUniqueID() });
    } else if (type === CARD_TYPES.PROFILE) {
      // Add profile at the end
      newMediaUrls.push("");
      newMediaData.push({ type: CARD_TYPES.PROFILE });
      newHeadlines.push({ value: "", id: getUniqueID() });
      newDescriptions.push({ value: "", id: getUniqueID() });
    }

    setValue(`${BASIC_PATH}.mediaUrls`, newMediaUrls);
    setValue(`${BASIC_PATH}.mediaData`, newMediaData);
    setValue(`${BASIC_PATH}.headlines`, newHeadlines);
    setValue(`${BASIC_PATH}.descriptions`, newDescriptions);

    onGeneratePreview();
  };

  const onRemoveCard = (type) => {
    const currentMediaUrls = watch(`${BASIC_PATH}.mediaUrls`) || [""];
    const currentMediaData = watch(`${BASIC_PATH}.mediaData`) || [{}];
    const currentHeadlines = watch(`${BASIC_PATH}.headlines`) || [
      { value: "" },
    ];
    const currentDescriptions = watch(`${BASIC_PATH}.descriptions`) || [
      { value: "" },
    ];

    const newMediaUrls = [...currentMediaUrls];
    const newMediaData = [...currentMediaData];
    const newHeadlines = [...currentHeadlines];
    const newDescriptions = [...currentDescriptions];

    // Find the index of the card to remove
    const indexToRemove = newMediaData.findIndex((item) => item.type === type);
    if (indexToRemove === -1) return;

    // Remove the card
    newMediaUrls.splice(indexToRemove, 1);
    newMediaData.splice(indexToRemove, 1);
    newHeadlines.splice(indexToRemove, 1);
    newDescriptions.splice(indexToRemove, 1);

    // Update tabIndex to show the previous card
    if (indexToRemove === tabIndex) {
      setTabIndex(Math.max(0, indexToRemove - 1));
    } else if (indexToRemove < tabIndex) {
      setTabIndex(tabIndex - 1);
    }

    setValue(`${BASIC_PATH}.mediaUrls`, newMediaUrls);
    setValue(`${BASIC_PATH}.mediaData`, newMediaData);
    setValue(`${BASIC_PATH}.headlines`, newHeadlines);
    setValue(`${BASIC_PATH}.descriptions`, newDescriptions);
    onGeneratePreview();
  };

  const isSalesWithOptionalCatalog =
    !platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const isApp =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    );

  const showAdSchedule = getShowAdScheduleMeta({ objective });
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: breakColumnFormAndPreview ? "column" : "row",
        gap: 3,
        width: "100%",
        flexWrap: showSlideChat ? "wrap" : "nowrap",
      }}
    >
      {/* Form */}
      <Grid
        container
        spacing={3}
        sx={{
          height: "min-content",
        }}
      >
        {/* Card Creative Source */}
        {showCreativeSource && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(CREATIVE_SOURCE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name={`${BASIC_PATH}.creativeSource`}
                  render={({ field }) => (
                    <FormControl component="fieldset">
                      <RadioGroup
                        value={field.value}
                        onChange={(e) => {
                          onChangeCreativeSource(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value={ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL}
                          control={<Radio />}
                          label={<Box>{t(MANUAL_UPLOAD_PLACEHOLDER)}</Box>}
                        />
                        <FormControlLabel
                          value={
                            ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
                          }
                          control={<Radio />}
                          label={<Box>{t(ADVANTAGE_CATALOG_PLACEHOLDER)}</Box>}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              </Grid>
            </CardContainer>
          </Grid>
        )}

        <ProductsConfiguration
          control={control}
          errors={errors}
          BASIC_PATH={BASIC_PATH}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          platformData={platformData}
          isGeneralDisabledFields={isGeneralDisabledFields}
          catalogID={catalogID}
          onGeneratePreview={onGeneratePreview}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
        />

        {/* Card  Creative Type */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(CREATIVE_TYPE_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Select
                  disabled={isGeneralDisabledFields || isAdCreated}
                  variant="filled"
                  name={`${BASIC_PATH}.creativeType`}
                  actionsChange={(value) => {
                    onChangeCreativeType(value);
                  }}
                  doTranslate={true}
                  control={control}
                  options={getCreativeTypes({
                    isSalesCampaign,
                    isAppPromotionCampaign,
                  })}
                />
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <DestinationFallbackConfiguration
                basicPath={BASIC_PATH}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                hideTitle={true}
                onCopyValuesInOtherAds={onCopyValuesInOtherAds}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 2: Preview Tabs */}
        <Grid item xs={12}>
          {errorMediaUrl && (
            <Grid item xs={12}>
              <Typography
                name={`${BASIC_PATH}.mediaUrls`}
                variant="body1"
                color="error"
                sx={{
                  mt: 2,
                  mb: -1,
                }}
              >
                {errorMediaUrl.message}
              </Typography>
            </Grid>
          )}

          {/* Preview Tabs */}
          <Grid item xs={12}>
            <Tabs
              value={tabIndex}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="Media tabs"
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                "& .MuiTab-root": {
                  color: "#000 !important",
                  "&.Mui-selected": {
                    color: "#000 !important",
                    backgroundColor: "#fff",
                    borderRadius: "4px 4px 0 0",
                  },
                  "&:hover": {
                    backgroundColor: "#fff",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "white",
                },
              }}
            >
              {mediaUrls?.map((_, index) => (
                <Tab
                  key={index}
                  label={t(CARD_TYPES_LABELS[mediaData?.[index]?.type])}
                />
              ))}
            </Tabs>
          </Grid>

          {/* Preview Cards Tabs*/}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: "100%",
              }}
            >
              {mediaUrls?.map((media, index) => {
                const description = descriptions[index] || { value: "" };
                const headline = headlines[index] || { value: "" };
                const mediaDataItem = mediaData?.[index] || {};

                return (
                  <Box
                    key={index}
                    sx={{
                      display: index === tabIndex ? "block" : "none",
                      width: "100%",
                    }}
                  >
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          backgroundColor: "fields.background",
                          border: `1px solid ${INPUT_COLOR_BORDER}`,
                          boxShadow: BOX_SHADOW_THEME,
                          p: 2,
                          borderRadius: 2,
                        }}
                      >
                        {!isGeneralDisabledFields && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            {mediaDataItem?.type !== CARD_TYPES.CATALOG && (
                              <IconButton
                                edge="end"
                                type="button"
                                onClick={(e) => {
                                  e?.stopPropagation();
                                  onRemoveCard(mediaDataItem?.type);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            )}
                            {mediaUrls.length < 3 && (
                              <ButtonMenu
                                mode="icon"
                                iconButton={<AddIcon />}
                                disabled={isGeneralDisabledFields}
                                options={[
                                  {
                                    label: INTRO_CARD,
                                    value: CARD_TYPES.INTRO,
                                    onClick: () => onAddCard(CARD_TYPES.INTRO),
                                  },
                                  {
                                    label: PROFILE_CARD,
                                    value: CARD_TYPES.PROFILE,
                                    onClick: () =>
                                      onAddCard(CARD_TYPES.PROFILE),
                                  },
                                ].filter((option) => {
                                  const hasIntroCard = mediaData.some(
                                    (data) => data.type === CARD_TYPES.INTRO
                                  );
                                  const hasProfileCard = mediaData.some(
                                    (data) => data.type === CARD_TYPES.PROFILE
                                  );

                                  if (
                                    option.value === CARD_TYPES.INTRO &&
                                    hasIntroCard
                                  )
                                    return false;
                                  if (
                                    option.value === CARD_TYPES.PROFILE &&
                                    hasProfileCard
                                  )
                                    return false;

                                  return true;
                                })}
                              />
                            )}
                          </Box>
                        )}

                        <Grid container spacing={0} sx={{ pb: 2, px: 2 }}>
                          {mediaDataItem?.type === CARD_TYPES.CATALOG && (
                            <Grid item xs={12}>
                              <Controller
                                name={`${BASIC_PATH}.mediaData.[${index}].creativeType`}
                                control={control}
                                render={({ field }) => (
                                  <FormControl
                                    component="fieldset"
                                    sx={{ mb: 2 }}
                                  >
                                    <FormLabel
                                      component="legend"
                                      sx={{
                                        mb: 1,
                                      }}
                                    >
                                      {t(CREATIVE_TYPE_PLACEHOLDER)}
                                    </FormLabel>
                                    <RadioGroup
                                      value={field.value}
                                      onChange={(e) => {
                                        field.onChange(e);
                                        onGeneratePreview();
                                      }}
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: 1,
                                        flexWrap: "nowrap",
                                      }}
                                    >
                                      <FormControlLabel
                                        value={CARD_CREATIVE_TYPES.SINGLE_IMAGE}
                                        control={<Radio sx={{ pt: 0.25 }} />}
                                        sx={{
                                          alignItems: "flex-start",
                                        }}
                                        label={
                                          <Box>
                                            <Typography variant="subtitle1">
                                              {t(SINGLE_IMAGE)}
                                            </Typography>
                                          </Box>
                                        }
                                      />
                                      <FormControlLabel
                                        value={CARD_CREATIVE_TYPES.SLIDES_SHOW}
                                        control={<Radio sx={{ pt: 0.25 }} />}
                                        sx={{
                                          alignItems: "flex-start",
                                        }}
                                        label={
                                          <Box>
                                            <Typography variant="subtitle1">
                                              {t(SLIDES_SHOW)}
                                            </Typography>
                                          </Box>
                                        }
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                )}
                              />
                            </Grid>
                          )}

                          <Grid item xs={12}>
                            <Grid container spacing={3}>
                              {mediaDataItem?.type !== CARD_TYPES.PROFILE && (
                                <Grid
                                  item
                                  xs={
                                    mediaDataItem?.type === CARD_TYPES.INTRO
                                      ? 8
                                      : 12
                                  }
                                >
                                  <Grid container spacing={3}>
                                    {/* Title */}
                                    <Grid
                                      item
                                      xs={12}
                                      id={`${BASIC_PATH}.headlines`}
                                    >
                                      <TextFieldWithActions
                                        isCatalogMeta={true}
                                        key={headline.id}
                                        labelTitle={t(HEADLINE_PLACEHOLDER)}
                                        type="headlines"
                                        name={`${BASIC_PATH}.headlines.[${index}].value`}
                                        disabled={isGeneralDisabledFields}
                                        platform={platform}
                                        showDeleteIcon={false}
                                        showAddIcon={
                                          mediaDataItem?.type ===
                                          CARD_TYPES.CATALOG
                                        }
                                        maxLength={maxLengthHeadline}
                                        onChange={onGeneratePreview}
                                        onGenerate={async () => {
                                          await onGenerateText({
                                            type: "headlines",
                                            index,
                                          });
                                        }}
                                        control={control}
                                        errors={errors}
                                      />
                                      {index === 0 && (
                                        <ClickableText
                                          disabled={isGeneralDisabledFields}
                                          onClick={() =>
                                            onCopyValuesInOtherAds({
                                              type: "headlines",
                                            })
                                          }
                                        >
                                          {t(COPY_VALUES_IN_OTHER_ADS)}
                                        </ClickableText>
                                      )}
                                    </Grid>

                                    {/* Description */}
                                    <Grid
                                      item
                                      xs={12}
                                      id={`${BASIC_PATH}.descriptions`}
                                    >
                                      <TextFieldWithActions
                                        isCatalogMeta={true}
                                        labelTitle={t(DESCRIPTION_PLACEHOLDER)}
                                        key={description.id}
                                        type="descriptions"
                                        name={`${BASIC_PATH}.descriptions.[${index}].value`}
                                        disabled={isGeneralDisabledFields}
                                        showDeleteIcon={false}
                                        platform={platform}
                                        showAddIcon={
                                          mediaDataItem?.type ===
                                          CARD_TYPES.CATALOG
                                        }
                                        maxLength={maxLengthDescription}
                                        onChange={onGeneratePreview}
                                        onGenerate={async () => {
                                          await onGenerateText({
                                            type: "descriptions",
                                            index,
                                          });
                                        }}
                                        control={control}
                                        errors={errors}
                                      />
                                      {index === 0 && (
                                        <ClickableText
                                          disabled={isGeneralDisabledFields}
                                          onClick={() =>
                                            onCopyValuesInOtherAds({
                                              type: "descriptions",
                                            })
                                          }
                                        >
                                          {t(COPY_VALUES_IN_OTHER_ADS)}
                                        </ClickableText>
                                      )}
                                    </Grid>

                                    {/* Deep Destination App URL */}
                                    {isAppPromotionCampaign &&
                                      !isIOS14Campaign && (
                                        <Grid item xs={12}>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: 1,
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <Typography variant="body1">
                                                {t(
                                                  DEEP_DESTINATION_APP_URL_PLACEHOLDER
                                                )}
                                              </Typography>
                                              <ChipOptional size="small" />
                                            </Box>
                                            <TextField
                                              name={`${BASIC_PATH}.destinationUrls.[${index}].value`}
                                              variant="filled"
                                              fullWidth
                                              disabled={isGeneralDisabledFields}
                                              control={control}
                                              errors={errors}
                                            />
                                            {index === 0 && (
                                              <ClickableText
                                                disabled={
                                                  isGeneralDisabledFields
                                                }
                                                onClick={() =>
                                                  onCopyValuesInOtherAds({
                                                    type: "destinationUrls",
                                                  })
                                                }
                                              >
                                                {t(COPY_VALUES_IN_OTHER_ADS)}
                                              </ClickableText>
                                            )}
                                          </Box>
                                        </Grid>
                                      )}
                                  </Grid>
                                </Grid>
                              )}

                              {/* Content */}
                              {mediaDataItem?.type === CARD_TYPES.INTRO && (
                                <Grid item xs={4}>
                                  <Grid item xs={12}>
                                    <ContentField
                                      platform={META}
                                      propsSelectContentComponent={{
                                        language,
                                        acceptedFormats:
                                          VIDEO_FORMATS.concat(IMAGE_FORMATS),
                                        showButtonUpload: true,
                                        showGenerateWithAIOption:
                                          destinationTypeAdGroup !==
                                          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                        showUploadDeviceOption:
                                          destinationTypeAdGroup !==
                                          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                        showGalleryOption:
                                          destinationTypeAdGroup !==
                                          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                        propsPostsAdsPlatforms: platformsData,
                                        destinationType: destinationTypeAdGroup,
                                        propsGenerateAI: {
                                          videoData: mediaDataItem?.videoID
                                            ? {
                                                ...mediaDataItem,
                                                id: mediaDataItem?.videoID,
                                              }
                                            : null,
                                          language,
                                          integrationID:
                                            platformData?.integrationID,
                                          adAccountID:
                                            platformData?.adAccountID,
                                          campaignContext: {
                                            objective,
                                            genders,
                                            ageRange,
                                          },
                                        },
                                      }}
                                      minDimensions={MIN_DIMENSIONS_CONTENT}
                                      onCallbackSave={({ from, content }) => {
                                        const contentFormatted =
                                          generalFormatMediaUrl({
                                            content,
                                            from,
                                          });
                                        dispatch(
                                          startDeleteAdMediaID({
                                            adID,
                                            index,
                                          })
                                        );
                                        setValue(
                                          `${BASIC_PATH}.mediaIDs.[${index}]`,
                                          ""
                                        );
                                        setValue(
                                          `${BASIC_PATH}.mediaUrls.[${index}]`,
                                          contentFormatted.url,
                                          {
                                            shouldValidate: true,
                                          }
                                        );
                                        const currentMediaData =
                                          mediaData?.[index] || {};
                                        setValue(
                                          `${BASIC_PATH}.mediaData.[${index}]`,
                                          {
                                            ...currentMediaData,
                                            ...(contentFormatted.mediaData ||
                                              {}),
                                          }
                                        );
                                        onGeneratePreview();
                                      }}
                                      label={t(CONTENT)}
                                      name={`${BASIC_PATH}.mediaUrls.[${index}]`}
                                      control={control}
                                      errors={errors}
                                      rules={{
                                        required: {
                                          value: true,
                                          message: t(FIELD_REQUIRED),
                                        },
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Box>
                );
              })}
            </Box>
          </Grid>
        </Grid>

        {/* Card 2: Creative Tools */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(EDIT_CREATIVE_TOOLS_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <EditCreativeTools
                  disabled={isGeneralDisabledFields}
                  control={control}
                  name={`${BASIC_PATH}.mediaData.[${catalogCardIndex}]`}
                  onActionChange={onGeneratePreview}
                  disableProductTagsOption={isAppPromotionCampaign}
                />
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {/* Card 3: URL Destination 2 Inputs */}
        {(isSalesCatalogCampaign || isSalesWithOptionalCatalog) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(ADS_CONFIGURATION_DESTINATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item {...gridItems}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(
                        isApp
                          ? DEEP_DESTINATION_APP_URL_PLACEHOLDER
                          : DESTINATION_URL_PLACEHOLDER
                      )}
                    </Typography>
                    <TextField
                      name={`${BASIC_PATH}.destinationUrls.[0].value`}
                      variant="filled"
                      fullWidth
                      disabled={isGeneralDisabledFields}
                      control={control}
                      errors={errors}
                      actionsChange={onGeneratePreview}
                    />
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "destinationUrls" })
                      }
                    >
                      {t(COPY_VALUES_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                </Grid>
                <Grid item {...gridItems}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {t(UTM_PARAMETERS_PLACEHOLDER)}
                      </Typography>
                      <ChipOptional size="small" />
                    </Box>
                    <UtmParametersContainer
                      name={`${BASIC_PATH}.utmParameters`}
                      control={control}
                      errors={errors}
                      disabled={isGeneralDisabledFields}
                      platform={platform}
                      onCopyValuesInOtherAds={() =>
                        onCopyValuesInOtherAds({ type: "utmParameters" })
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 4: Map Custom Page ID */}
        {isAppPromotionCampaign && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6">
                    {t(MAP_CUSTOM_PAGE_ID_PLACEHOLDER[destinationTypeAdGroup])}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <TextField
                    name={`${BASIC_PATH}.appProductPageID`}
                    variant="filled"
                    fullWidth
                    disabled={isGeneralDisabledFields}
                    control={control}
                    errors={errors}
                  />
                  <ClickableText
                    disabled={isGeneralDisabledFields}
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "appProductPageID" })
                    }
                  >
                    {t(COPY_VALUES_IN_OTHER_ADS)}
                  </ClickableText>
                </Box>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: Call to Action */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(CALL_TO_ACTION_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <SelectCallToActionMeta
                  disabled={isGeneralDisabledFields}
                  name={`${BASIC_PATH}.callToAction`}
                  fullWidth
                  objective={objective}
                  platform={platform}
                  destinationType={destinationTypeAdGroup}
                  doTranslate={true}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <ClickableText
                  disabled={isGeneralDisabledFields}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "callToAction" })
                  }
                >
                  {t(COPY_VALUES_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {(showTrackingID || showTrackingOfflineID) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(TRACKING_EVENTS)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showTrackingID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_WEBSITE_EVENTS)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
                {showTrackingOfflineID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingOfflineID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showAdSchedule && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <AdScheduleContainerMeta
                BASIC_PATH={`${BASIC_PATH}`}
                control={control}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 7: Titles */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.titles`}
        >
          <CardContainerWithCopy
            title={t(TITLES_META)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "titles" })}
            id={`${BASIC_PATH}.titles`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {titles?.map((title, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  labelTitle={t(TITLE_PLACEHOLDER) + " " + (index + 1)}
                  key={title.id}
                  type="titles"
                  showDeleteIcon={false}
                  name={`${BASIC_PATH}.titles.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  maxLength={maxLengthTitle}
                  platform={platform}
                  onChange={onGeneratePreview}
                  onGenerate={async () => {
                    await onGenerateText({ type: "titles", index });
                  }}
                  control={control}
                  errors={errors}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>
      </Grid>

      {/* Preview Card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
        }}
      >
        <CardContainer
          dynamicHeight={true}
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ fontWeight: 600 }} variant="h6">
                {t(ADS_CAMPAIGN_PREVIEW)}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {!isGeneralDisabledFields && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <EditAdvantageEnhances
                      disabled={isGeneralDisabledFields}
                      adID={adID}
                      adPathForm={BASIC_PATH}
                      onCallbackSelect={(newAdvantageEnhances) => {
                        setValue(
                          `${BASIC_PATH}.advantageEnhances`,
                          newAdvantageEnhances
                        );
                        onGeneratePreview();
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AdPreviewMeta
              adID={adID}
              platform={platform}
              ref={refPreview}
              mediaUrls={mediaUrls}
              mediaData={mediaData}
              callToAction={callToAction}
              titles={titles}
              headlines={headlines}
              descriptions={descriptions}
              destinationUrls={destinationUrls}
              basicPath={BASIC_PATH}
              basicPathAdGroup={BASIC_PATH_AD_GROUP}
            />
          </Box>
        </CardContainer>
      </Box>
    </Box>
  );
};

const AdSingleMediaCatalogForm = ({
  objective,
  platform,
  breakColumnFormAndPreview,
  BASIC_PATH_AD_GROUP,
  BASIC_PATH,
  gridItems,
  onGenerateText,
  isSpecialAdWithOnlyTitles,
  isGeneralDisabledFields,
  errors,
  control,
  refPreview,
  onChangeCreativeType,
  onGeneratePreview,
  onCopyValuesInOtherAds,
  platformData,
  onChangeCreativeSource,
  catalogID,
  showCreativeSource,
  showSlideChat,
  showDestinationFallbackConfiguration,
}) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();

  const isSalesCampaign = objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const isAppPromotionCampaign =
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION;

  const maxLengthTitle = ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH[platform];
  const maxLengthDescription =
    ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH[platform];
  const maxLengthHeadline = ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH[platform];

  const adID = watch(`${BASIC_PATH}.id`);

  const mediaUrls = watch(`${BASIC_PATH}.mediaUrls`);
  const mediaData = watch(`${BASIC_PATH}.mediaData`);
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const titles = watch(`${BASIC_PATH}.titles`) || [{ value: "" }];
  const headlines = watch(`${BASIC_PATH}.headlines`) || [{ value: "" }];
  const descriptions = watch(`${BASIC_PATH}.descriptions`) || [{ value: "" }];
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );

  const status = watch(`${BASIC_PATH}.status`);
  const isAdCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;

  const showTrackingID =
    !(
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationTypeAdGroup ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      !platformData.isCatalogCampaign
    ) &&
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.filter(
      (i) => i !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    ).includes(destinationTypeAdGroup);

  const showTrackingOfflineID =
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationTypeAdGroup
    );

  const isSalesCatalogCampaign =
    platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const isSalesWithOptionalCatalog =
    !platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const isApp =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    );

  const showAdSchedule = getShowAdScheduleMeta({ objective });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: breakColumnFormAndPreview ? "column" : "row",
        gap: 4,
        width: "100%",
        flexWrap: showSlideChat ? "wrap" : "nowrap",
      }}
    >
      {/* Form */}
      <Grid
        container
        spacing={3}
        sx={{
          height: "min-content",
        }}
      >
        {/* Card Creative Source */}
        {showCreativeSource && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(CREATIVE_SOURCE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name={`${BASIC_PATH}.creativeSource`}
                  render={({ field }) => (
                    <FormControl component="fieldset">
                      <RadioGroup
                        value={field.value}
                        onChange={(e) => {
                          onChangeCreativeSource(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value={ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL}
                          control={<Radio />}
                          label={<Box>{t(MANUAL_UPLOAD_PLACEHOLDER)}</Box>}
                        />
                        <FormControlLabel
                          value={
                            ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
                          }
                          control={<Radio />}
                          label={<Box>{t(ADVANTAGE_CATALOG_PLACEHOLDER)}</Box>}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              </Grid>
            </CardContainer>
          </Grid>
        )}

        <ProductsConfiguration
          control={control}
          errors={errors}
          BASIC_PATH={BASIC_PATH}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          platformData={platformData}
          isGeneralDisabledFields={isGeneralDisabledFields}
          catalogID={catalogID}
          onGeneratePreview={onGeneratePreview}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
        />

        {/* Card 1: Creative Type */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(CREATIVE_TYPE_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Select
                  disabled={isGeneralDisabledFields || isAdCreated}
                  variant="filled"
                  name={`${BASIC_PATH}.creativeType`}
                  doTranslate={true}
                  actionsChange={(value) => {
                    onChangeCreativeType(value);
                  }}
                  control={control}
                  options={getCreativeTypes({
                    isSalesCampaign,
                    isAppPromotionCampaign,
                  })}
                />
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {/* Card 2: Creative Tools */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(EDIT_CREATIVE_TOOLS_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <EditCreativeTools
                  disabled={isGeneralDisabledFields}
                  control={control}
                  name={`${BASIC_PATH}.mediaData.[0]`}
                  onActionChange={onGeneratePreview}
                  disableProductTagsOption={isAppPromotionCampaign}
                />
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <DestinationFallbackConfiguration
                basicPath={BASIC_PATH}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                hideTitle={true}
                onCopyValuesInOtherAds={onCopyValuesInOtherAds}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 3: URL Destination */}
        {(isSalesCatalogCampaign || isSalesWithOptionalCatalog) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(ADS_CONFIGURATION_DESTINATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item {...gridItems}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(
                        isApp
                          ? DEEP_DESTINATION_APP_URL_PLACEHOLDER
                          : DESTINATION_URL_PLACEHOLDER
                      )}
                    </Typography>
                    <TextField
                      name={`${BASIC_PATH}.destinationUrls.[0].value`}
                      variant="filled"
                      fullWidth
                      disabled={isGeneralDisabledFields}
                      control={control}
                      errors={errors}
                      actionsChange={onGeneratePreview}
                    />
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "destinationUrls" })
                      }
                    >
                      {t(COPY_VALUES_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                </Grid>
                <Grid item {...gridItems}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {t(UTM_PARAMETERS_PLACEHOLDER)}
                      </Typography>
                      <ChipOptional size="small" />
                    </Box>
                    <UtmParametersContainer
                      name={`${BASIC_PATH}.utmParameters`}
                      control={control}
                      errors={errors}
                      disabled={isGeneralDisabledFields}
                      platform={platform}
                      onCopyValuesInOtherAds={() =>
                        onCopyValuesInOtherAds({ type: "utmParameters" })
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {isAppPromotionCampaign && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6">
                    {t(MAP_CUSTOM_PAGE_ID_PLACEHOLDER[destinationTypeAdGroup])}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <TextField
                    name={`${BASIC_PATH}.appProductPageID`}
                    variant="filled"
                    fullWidth
                    disabled={isGeneralDisabledFields}
                    control={control}
                    errors={errors}
                  />
                  <ClickableText
                    disabled={isGeneralDisabledFields}
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "appProductPageID" })
                    }
                  >
                    {t(COPY_VALUES_IN_OTHER_ADS)}
                  </ClickableText>
                </Box>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: Call to Action */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: 600 }} variant="h6">
                  {t(CALL_TO_ACTION_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <SelectCallToActionMeta
                  disabled={isGeneralDisabledFields}
                  name={`${BASIC_PATH}.callToAction`}
                  fullWidth
                  objective={objective}
                  platform={platform}
                  destinationType={destinationTypeAdGroup}
                  doTranslate={true}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <ClickableText
                  disabled={isGeneralDisabledFields}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "callToAction" })
                  }
                >
                  {t(COPY_VALUES_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </Grid>
          </CardContainer>
        </Grid>

        {(showTrackingID || showTrackingOfflineID) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(TRACKING_EVENTS)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showTrackingID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_WEBSITE_EVENTS)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
                {showTrackingOfflineID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingOfflineID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showAdSchedule && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <AdScheduleContainerMeta
                BASIC_PATH={`${BASIC_PATH}`}
                control={control}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 7: Titles */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.titles`}
        >
          <CardContainerWithCopy
            title={t(TITLES_META)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "titles" })}
            id={`${BASIC_PATH}.titles`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box
              lg={isSpecialAdWithOnlyTitles ? 12 : 6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {titles?.map((title, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  key={title.id}
                  type="titles"
                  labelTitle={t(TITLE_PLACEHOLDER) + " " + (index + 1)}
                  name={`${BASIC_PATH}.titles.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  platform={platform}
                  onChange={onGeneratePreview}
                  maxLength={maxLengthTitle}
                  showDeleteIcon={false}
                  onGenerate={async () => {
                    await onGenerateText({ type: "titles", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                    validate: (value) => {
                      if (value.length > maxLengthTitle) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthTitle,
                        });
                      }

                      const allTitles = titles.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allTitles.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) {
                        return t(FIELD_TEXT_REPEATED);
                      }
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>

        {/* Card 7: Descriptions */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.descriptions`}
        >
          <CardContainerWithCopy
            title={t(DESCRIPTIONS)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() =>
              onCopyValuesInOtherAds({ type: "descriptions" })
            }
            id={`${BASIC_PATH}.descriptions`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {descriptions?.map((description, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  key={description.id}
                  labelTitle={t(DESCRIPTION_PLACEHOLDER) + " " + (index + 1)}
                  type="descriptions"
                  name={`${BASIC_PATH}.descriptions.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  platform={platform}
                  maxLength={maxLengthDescription}
                  onChange={onGeneratePreview}
                  showDeleteIcon={false}
                  onGenerate={async () => {
                    await onGenerateText({ type: "descriptions", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                    validate: (value) => {
                      if (value.length > maxLengthDescription) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthDescription,
                        });
                      }
                      const allDescriptions = descriptions.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allDescriptions.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) {
                        return t(FIELD_TEXT_REPEATED);
                      }
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>

        {/* Card 8: Headlines */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.headlines`}
        >
          <CardContainerWithCopy
            title={t(HEADLINES)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "headlines" })}
            id={`${BASIC_PATH}.headlines`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {headlines?.map((headline, index) => (
                <TextFieldWithActions
                  isCatalogMeta={true}
                  key={headline.id}
                  labelTitle={t(HEADLINE_PLACEHOLDER) + " " + (index + 1)}
                  type="headlines"
                  name={`${BASIC_PATH}.headlines.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  platform={platform}
                  onChange={onGeneratePreview}
                  maxLength={maxLengthHeadline}
                  onGenerate={async () => {
                    await onGenerateText({ type: "headlines", index });
                  }}
                  showDeleteIcon={false}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                    validate: (value) => {
                      if (value.length > maxLengthHeadline) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthHeadline,
                        });
                      }
                      const allHeadlines = headlines.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allHeadlines.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) {
                        return t(FIELD_TEXT_REPEATED);
                      }
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>
      </Grid>

      {/* Preview Card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
        }}
      >
        <CardContainer
          dynamicHeight={true}
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ fontWeight: 600 }} variant="h6">
                {t(ADS_CAMPAIGN_PREVIEW)}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {!isGeneralDisabledFields && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <EditAdvantageEnhances
                      disabled={isGeneralDisabledFields}
                      adID={adID}
                      adPathForm={BASIC_PATH}
                      onCallbackSelect={(newAdvantageEnhances) => {
                        setValue(
                          `${BASIC_PATH}.advantageEnhances`,
                          newAdvantageEnhances
                        );
                        onGeneratePreview();
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AdPreviewMeta
              ref={refPreview}
              adID={adID}
              mediaUrls={mediaUrls}
              mediaData={mediaData}
              callToAction={callToAction}
              titles={titles}
              headlines={headlines}
              descriptions={descriptions}
              platform={platform}
              basicPath={BASIC_PATH}
              basicPathAdGroup={BASIC_PATH_AD_GROUP}
            />
          </Box>
        </CardContainer>
      </Box>
    </Box>
  );
};

// eslint-disable-next-line no-unused-vars
const AppConfiguration = ({
  control,
  errors,
  disabled,
  BASIC_PATH,
  BASIC_PATH_AD_GROUP,
  platformData,
  onCopyValuesInOtherAds,
}) => {
  const { t } = useTranslationApp();
  const { watch } = useFormContext();

  const objective = platformData.objective;
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );
  const isSalesWithAppAndCatalog =
    !platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    );

  return (
    <>
      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography sx={{ fontWeight: 600 }} variant="h6">
                {t(ADS_CONFIGURATION_APPS_TITLE)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={2}>
            {!isSalesWithAppAndCatalog && (
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    {t(APP_PLACEHOLDER)}
                  </Typography>
                  <SelectAdvertisableAppsMeta
                    disabled={disabled}
                    platform={META}
                    adAccountID={platformData?.adAccountID}
                    integrationID={platformData?.integrationID}
                    name={`${BASIC_PATH}.appConfiguration.appID`}
                    fullWidth
                    variant="filled"
                    control={control}
                    errors={errors}
                  />
                  <ClickableText
                    disabled={disabled}
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "appConfiguration" })
                    }
                  >
                    {t(COPY_VALUES_IN_OTHER_ADS)}
                  </ClickableText>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <TextFieldWithActions
                  isCatalogMeta={true}
                  labelTitle={t(ANDROID_DEEP_LINK_PLACEHOLDER)}
                  type="destinationUrl"
                  name={`${BASIC_PATH}.appConfiguration.androidDeepLink`}
                  disabled={disabled}
                  platform={META}
                  onChange={() => {}}
                  control={control}
                  errors={errors}
                  showCounterCharacters={false}
                  showDeleteIcon={false}
                />
                <ClickableText
                  disabled={disabled}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "appConfiguration" })
                  }
                >
                  {t(COPY_VALUES_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <TextFieldWithActions
                  isCatalogMeta={true}
                  labelTitle={t(IOS_DEEP_LINK_PLACEHOLDER)}
                  type="destinationUrl"
                  name={`${BASIC_PATH}.appConfiguration.iosDeepLink`}
                  disabled={disabled}
                  platform={META}
                  onChange={() => {}}
                  control={control}
                  errors={errors}
                  showCounterCharacters={false}
                  showDeleteIcon={false}
                />
                <ClickableText
                  disabled={disabled}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "appConfiguration" })
                  }
                >
                  {t(COPY_VALUES_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </Grid>
          </Grid>
        </CardContainer>
      </Grid>
    </>
  );
};

const ProductsConfiguration = ({
  control,
  errors,
  BASIC_PATH,
  platformData,
  catalogID,
  onGeneratePreview,
  onCopyValuesInOtherAds,
  isGeneralDisabledFields,
}) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();

  const objective = platformData.objective;
  const isSalesWithOptionalCatalog =
    !platformData.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;

  const productSetID = watch(`${BASIC_PATH}.productSetID`);

  if (!isSalesWithOptionalCatalog) return null;

  return (
    <Grid item xs={12}>
      <CardContainer
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Widgets
              sx={{
                color: "#FFFFFF",
                width: 24,
                height: 24,
                fontWeight: 600,
              }}
            />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {t(ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE)}
            </Typography>
          </Box>
        }
      >
        <Grid container spacing={2}>
          {isSalesWithOptionalCatalog &&
            ((productSetID && catalogID) || !productSetID) && (
              <Grid item xs={isSalesWithOptionalCatalog ? 6 : 12}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {t(CATALOG_PLACEHOLDER)}
                </Typography>
                <SelectCatalogMeta
                  fullWidth
                  variant="filled"
                  disabled={!isSalesWithOptionalCatalog}
                  platform={META}
                  integrationID={platformData?.integrationID}
                  adAccountID={platformData?.adAccountID}
                  control={control}
                  name={`${BASIC_PATH}.catalogID`}
                  onChangeAction={() =>
                    setValue(`${BASIC_PATH}.productSetID`, "")
                  }
                  errors={errors}
                />
                <ClickableText
                  disabled={isGeneralDisabledFields}
                  onClick={() => onCopyValuesInOtherAds({ type: "catalogID" })}
                >
                  {t(COPY_VALUES_IN_OTHER_ADS)}
                </ClickableText>
              </Grid>
            )}
          <Grid item xs={isSalesWithOptionalCatalog ? 6 : 12}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              {t(PROMOTED_PRODUCTS_PLACEHOLDER)}
            </Typography>
            <SelectProductsSetMeta
              fullWidth
              variant="filled"
              disabled={!isSalesWithOptionalCatalog}
              platform={META}
              integrationID={platformData?.integrationID}
              adAccountID={platformData?.adAccountID}
              catalogID={catalogID}
              control={control}
              name={`${BASIC_PATH}.productSetID`}
              errors={errors}
              onChangeAction={(_, catalog) => {
                if (!catalogID && catalog) {
                  setValue(`${BASIC_PATH}.catalogID`, catalog.id);
                }
                onGeneratePreview();
              }}
            />
            <ClickableText
              disabled={isGeneralDisabledFields}
              onClick={() => onCopyValuesInOtherAds({ type: "productSetID" })}
            >
              {t(COPY_VALUES_IN_OTHER_ADS)}
            </ClickableText>
          </Grid>
        </Grid>
      </CardContainer>
    </Grid>
  );
};

export default AdCatalogMetaForm;
